import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from '../core/services/environment.service';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { StorageService } from '../core/services/storage.service';
import { IdentityService } from '../identity.service';

@Component({
  selector: 'app-auth',
  template: `<router-outlet></router-outlet>`
})
export class AuthComponent implements OnInit {
  currentStore: string;
  translateService: any;

  constructor(
    private envService: EnvironmentService,
    private authService: AuthService,
    private storageService: StorageService,
    private router: Router,
    private identityService : IdentityService
  ) {
  }

  public checkQueryString(queryString: string) {

    if (queryString) {
      queryString = queryString.substring(1);
      const queryParams = queryString.split('&');

      queryParams.forEach( (query, index) => {
        console.log(queryParams);
        const queryPair = query.split('=');
        // Save the store parameter if exists
        switch ( queryPair[0] ) {
          case 'theme':
          case 'store':
              this.currentStore = this.envService.setStore(queryPair[1]);
           break;

          case 'expires_in':
            this.storageService.setLocalItem( queryPair[0], queryPair[1] );
            break;

          case 'lang':
          // this.storageService.setLocalItem( queryPair[0], queryPair[1] );
          this.translateService.use(queryPair[1]);
          break;

          case 'code':   
          console.log(queryPair[1]);
            this.identityService.getAccessTokenFromCode(queryPair[1]).toPromise().then(
              (tokenResponse : any) => {
                console.log("token reponse" , tokenResponse.json().id_token)
                this.storageService.setLocalItem( "access_token", tokenResponse.json().id_token );
                const redirectUrl = this.envService.get('homePage');   
                if (redirectUrl) {
                  setTimeout(()=> {
                    window.location.href = redirectUrl;
                  }, 5000);
                }
          }, (error => {
            console.log(error)
          }));
            break;
        }
      });
    }
  }

  ngOnInit() {
    console.log("On init")
    console.log(window.location.search)
    this.checkQueryString(window.location.search);
   
  }
}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/auth/auth.component.ts